<template>
<div>
  <div class="row mt-2 ml-0 mb-4">
    <div class="col col-12 col-md-10 text-justify">
      Ingresa la firma del acudiente. Esta firma, se utilizará con fines de creación
      de la ficha de matricula del estudiante, la cual es <b>requisito</b> para la creación
      del libro de matriculas solicitado por la secretaría de educación.
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col col-12 col-md-10" v-show="!signatureData.state">
      <canvas class="responsive-canvas"
        width="800" height="200" id="signatureCanvas"
        @mousedown="mousedown" @mousemove="mousemove"
        @mouseup="sign = false" @mouseout="sign = false"
        @touchstart="mousedown" @touchmove="mousemove"
        @touchend="sign = false" />
    </div>
    <div class="col col-12 col-md-10" v-show="signatureData.state">
      <img class="responsive-canvas" :src="signatureData.path">
    </div>
    <div class="col col-11 col-md-2 pl-md-0" v-if="!signatureData.state">
      <div class="row align-items-center justify-content-center">
        <b-col class="col col-md-10">
          <b-button type="button" block variant="primary" @click="sendSignature()">Guardar cambios</b-button>
        </b-col>
        <b-col class="col col-md-10">
          <b-button block class="mt-3" variant="primary" @click="cleanCanvas()" type="button">Limpiar</b-button>
        </b-col>
        <b-col class="col col-md-10" v-show="isNewSignature">
          <b-button type="button" block variant="secondary" @click="cancelUpdate()" class="mb-3 mt-3">Cancelar</b-button>
        </b-col>
      </div>
    </div>
    <div class="col col-11 col-md-2 pl-md-0" v-else>
      <div class="row align-items-center justify-content-center">
        <b-col class="col col-md-10">
          <b-button block variant="primary" @click="newSignature()" type="button">Actualizar</b-button>
        </b-col>
      </div>
    </div>
  </div>
</div>
</template>
<style scoped>
canvas {
    border: 1px solid #e4e9f0;
    background-color: white;
    cursor: crosshair;
}
.responsive-canvas {
  width: 100%;
  border-radius: 0.5rem;
  max-width: max-content;
}
</style>
<script>
export default {
  props: {
    signatureData: {
      type: Object,
    },
  },
  data() {
    return {
      ctx: null,
      sign: false,
      prevX: 0,
      prevY: 0,
      img: '',
      isNewSignature: false,
    }
  },
  methods: {
    cleanCanvas() {
      var c = document.getElementById('signatureCanvas')
      this.ctx.clearRect(0, 0, c.width, c.height)
    },
    mousedown($event) {
      this.sign = true
      this.prevX = $event.offsetX
      this.prevY = $event.offsetY
    },
    mousemove($event) {
      if (this.sign) {
        const currX = $event.offsetX
        const currY = $event.offsetY
        this.draw(this.prevX, this.prevY, currX, currY)
        this.prevX = currX
        this.prevY = currY
      }
    },
    draw(depX, depY, destX, destY) {
      this.ctx.beginPath()
      this.ctx.moveTo(depX, depY)
      this.ctx.lineTo(destX, destY)
      this.ctx.closePath()
      this.ctx.stroke()
      const canvas = document.getElementById('signatureCanvas')
      this.img = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
    },
    sendSignature() {
      this.$emit('drawing', this.img)
    },
    newSignature() {
      this.isNewSignature = true
      this.signatureData.state = false
    },
    cancelUpdate() {
      this.isNewSignature = false
      this.signatureData.state = true
    },
  },
  mounted() {
    this.signatureData = { ...this.signatureData }
    var c = document.getElementById('signatureCanvas')
    this.ctx = c.getContext('2d')
    this.ctx.strokeStyle = 'black'
    this.ctx.lineWidth = 2
  },
}
</script>
